import React from "react";
import "./Tabs.css";

export interface TabItem {
  /**
   * Texto del tab
   */
  label: string;
  /**
   * Valor del badge (opcional)
   */
  badgeCount?: number;
  /**
   * Si el tab está seleccionado
   */
  selected?: boolean;
  /**
   * Si el tab está deshabilitado
   */
  disabled?: boolean;
}

export interface TabsProps {
  /**
   * Lista de tabs a mostrar
   */
  items: TabItem[];
  /**
   * Callback cuando se selecciona un tab
   */
  onSelect?: (index: number) => void;
  /**
   * Índice del tab seleccionado
   */
  selectedIndex?: number;
  /**
   * Clase CSS adicional
   */
  className?: string;
  /**
   * Si el tab no debe meter saltos de linea
   */
  noWrap?: boolean;
}

export const Tabs: React.FC<TabsProps> = ({
  items,
  onSelect,
  selectedIndex = 0,
  className = "",
  noWrap = false,
}) => {
  const handleClick = (index: number) => {
    if (!items[index].disabled && onSelect) {
      onSelect(index);
    }
  };

  return (
    <div className={`qida-tabs ${noWrap ? "whitespace-nowrap overflow-y-hidden" : ""} ${className}`}>
      {items.map((item, index) => {
        const tabClasses = [
          "qida-tab",
          item.selected || index === selectedIndex ? "qida-tab--selected" : "",
          item.disabled ? "qida-tab--disabled" : "",
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <button
            key={index}
            className={tabClasses}
            onClick={() => handleClick(index)}
            disabled={item.disabled}
            role="tab"
            aria-selected={item.selected || index === selectedIndex}
            tabIndex={item.disabled ? -1 : 0}
          >
            <div className="qida-tab__content">
              <span className="qida-tab__label">{item.label}</span>
              {typeof item.badgeCount !== "undefined" && (
                <div
                  className={`qida-tab__badge ${item.selected || index === selectedIndex ? "qida-tab__badge--selected" : ""}`}
                >
                  <span className="qida-tab__badge-label">
                    {item.badgeCount}
                  </span>
                </div>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
